<template>
    <div>
        <div class="file_name">{{ file.name }}</div>
        <div class="ico" :title="file.name">
            <i v-if="notImage" :class="iconForType"></i>
            <img v-else :src="thumbUrl" />
        </div>
    </div>
</template>

<script>
    import { FileTypes } from "@/ts/buildingSpec";

    export default {
        name: 'fileItem',
        props: {
            file: null,
        },
        computed: {
            notImage() {
                return this.file.type !== FileTypes.img;
            },
            thumbUrl() {
                return `${this.$currentConfig.apiBaseUrl}${this.file.thumb}`;
            },
            iconForType() {
                var respVal = "far fa-question-circle fa-2x";//for other, imgs use thumnails so never get here
                if (this.file.type == FileTypes.vid) {
                    respVal = "fas fa-film fa-2x md-info";
                }
                else if (this.file.type == FileTypes.xls) {
                    respVal = "far fa-file-excel fa-2x md-success"
                }
                else if (this.file.type == FileTypes.csv) {
                    respVal = "fas fa-file-csv fa-2x md-success";
                }
                else if (this.file.type == FileTypes.pdf) {
                    respVal = "far fa-file-pdf fa-2x md-danger";
                }
                else if (this.file.type == FileTypes.word) {
                    respVal = "far fa-file-word fa-2x md-info";
                }
                else if (this.file.type == FileTypes.ppt) {
                    respVal = "far fa-file-powerpoint fa-2x md-primary";
                }
                return respVal;
            }
        }
    }
</script>

<style lang="scss">

    .file_name {
        width: calc(100% - 28px);
        overflow-wrap: anywhere;
    }

    .ico {
        width: 28px;
        height: 28px;
        text-align: center;
    }

        .ico img {
            width: 28px;
            height: 28px;
        }

        .ico i.md-success {
            color: #4caf50 !important;
        }

        .ico i.md-info {
            color: #448aff !important;
        }

        .ico i.md-danger {
            color: indianred !important;
        }
</style>
